export const NO_WHATSAPP_COMMUNITY_AVAILABLE_FOR_INCENTIVE_ERROR_NAME =
  'NoWhatsAppCommunityAvailableForIncentiveError';

export class NoWhatsAppCommunityAvailableForIncentiveError extends Error {
  name: string = NO_WHATSAPP_COMMUNITY_AVAILABLE_FOR_INCENTIVE_ERROR_NAME;

  constructor(incentiveId?: string) {
    super(NoWhatsAppCommunityAvailableForIncentiveError.fmt(incentiveId));
  }

  static fmt(incentiveId?: string) {
    if (typeof incentiveId === 'string') {
      return `No WhatsApp Community available for incentive with id ${incentiveId}.`;
    }

    return `No WhatsApp Community available for incentive.`;
  }
}
